import { createServiceStore } from 'common/store';
import { initialState } from './constants';
export var useBenefitCompanyBalanceStore = createServiceStore({
    initialValues: initialState,
});
